exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/sree/New folder (3)/cdk-material-v2/src/app/core/sidemenu/sidemenu.component.scss
// module id = ../../../../../src/app/core/sidemenu/sidemenu.component.scss
// module chunks = main